import {headers, parseJSON} from './apiUtils';
import RequestWatcher from './request-watcher';
import store from './store';
import {PollingIntervals} from './constants';

let authHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded'
};

export function getServerState() {
    const options = {
        headers: headers(),
        method: 'GET'
    };

    return fetch('/api/Helper/ServerState', options).then(parseJSON);
}

export function postSession(email, password, desktopAttemptingLogin) {
    const parameters = {
        grant_type: 'password',
        username: email,
        password: password,
        desktopAttemptingLogin: desktopAttemptingLogin
    };
    const formBody = Object.keys(parameters)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key]))
        .join('&');
    const options = {
        headers: authHeaders,
        method: 'POST',
        body: formBody
    };

    return fetch('/Token', options).then(parseJSON);
}

export function deleteSession(session) {
    if (session.uri) {
        const options = {
            headers: headers(),
            method: 'DELETE'
        };
        return fetch(session.uri, options).then(parseJSON);
    }
}

let sessionItemsWatcher;

export function watchSessionItems() {
    const urlFunction = () => {
        const currentState = store.getState();
        return `/api/Helper/SessionItems?clientId=${currentState.session.clientId}`;
    };

    sessionItemsWatcher = new RequestWatcher({pollTimeout: PollingIntervals.long}).watch(urlFunction);
    return sessionItemsWatcher;
}

export function unwatchSessionItems() {
    if (sessionItemsWatcher) {
        sessionItemsWatcher.stop();
    }
}

export function postForgotPassword(userName, typeKey) {
    const options = {
        headers: headers(),
        method: 'POST'
    };

    return fetch(`/api/TemporaryLink?userName=${userName}&typeKey=${typeKey}`, options).then(parseJSON);
}

export function getTemporaryLink(temporaryLinkText) {
    const options = {
        headers: headers(),
        method: 'GET'
    };

    return fetch(`/api/TemporaryLink?linkText=${temporaryLinkText}`, options).then(parseJSON);
}

export function postResetPassword(temporaryLinkText, password1, password2) {
    const options = {
        headers: headers(),
        method: 'POST'
    };

    return fetch(
        `/api/TemporaryLink/ResetPassword?linkText=${temporaryLinkText}&password1=${encodeURIComponent(
            password1
        )}&password2=${encodeURIComponent(password2)}`,
        options
    ).then(parseJSON);
}

export function postUser(user) {
    return fetch('/api/User/Self', {
        headers: headers(),
        method: 'POST',
        body: JSON.stringify(user)
    }).then(parseJSON);
}

export function getClient(clientId) {
    return fetch('/api/CustomerFacingSurvey/GetClientById?clientId=' + clientId, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}
